export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.24-1519.59",
  commitId: "f3d898e6a9b58420fac9d55a9a9f2fbc0b2711e7",
  commitTime: "2026-07-24T15:19:59.000Z",
});
